import React from 'react';
import { motion } from 'framer-motion';
import { FlagDivider } from './FlagDivider';
import { BookOpen, Headphones } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative flex flex-col items-center justify-center overflow-hidden bg-[#0a0a0a] pt-20 sm:pt-24 pb-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8" data-id="element-36">
      {/* Background subtle gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-[#0a0a0a] to-[#111] opacity-80 z-0" data-id="element-37" />

      <div className="relative z-10 max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-center" data-id="element-38">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-39">
          <div className="inline-block mb-4 sm:mb-6 px-3 py-1 border border-zinc-800 rounded-full bg-zinc-900/50 backdrop-blur-sm" data-id="element-40">
            <span className="text-zinc-400 text-xs sm:text-sm font-medium tracking-wide uppercase" data-id="element-41">
              AudioLibro + eBook
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-tight mb-4 sm:mb-6" data-id="element-42">
            VENEZUELA: <br data-id="element-43" />
            <span className="text-zinc-400 italic font-normal text-2xl sm:text-3xl lg:text-4xl xl:text-5xl block mt-1 sm:mt-2" data-id="element-44">
              La verdad que el mundo no quiso ver.
            </span>
          </h1>

          <p className="text-base sm:text-lg lg:text-xl text-zinc-300 mb-6 sm:mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0 font-light" data-id="element-45">
            Si eres venezolano (o tienes a Venezuela en el corazón), esto te va
            a doler… y te va a dar claridad.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start items-center mb-6 sm:mb-8" data-id="element-46">
            <button onClick={scrollToPricing} className="bg-[#FFCC00] hover:bg-[#e6b800] text-[#0a0a0a] font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-lg transition-all transform hover:scale-105 shadow-lg shadow-yellow-900/20 w-full sm:w-auto text-base sm:text-lg" data-id="element-47">
              Comprar Ahora — $19.97
            </button>
            <div className="flex items-center gap-3 sm:gap-4 text-zinc-400 text-xs sm:text-sm" data-id="element-48">
              <span className="flex items-center gap-1" data-id="element-49">
                <BookOpen size={14} className="sm:w-4 sm:h-4" data-id="element-50" /> eBook PDF
              </span>
              <span className="w-1 h-1 bg-zinc-600 rounded-full" data-id="element-51"></span>
              <span className="flex items-center gap-1" data-id="element-52">
                <Headphones size={14} className="sm:w-4 sm:h-4" data-id="element-53" /> Audio MP3
              </span>
            </div>
          </div>

          <FlagDivider className="max-w-[150px] sm:max-w-[200px] mx-auto lg:mx-0 opacity-70" data-id="element-54" />
        </motion.div>

        {/* Book Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="order-1 lg:order-2 flex justify-center" data-id="element-55">
          <div className="relative group" data-id="element-56">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#FFCC00] via-[#00247D] to-[#CF142B] rounded-lg blur opacity-20 group-hover:opacity-40 transition duration-1000" data-id="element-57"></div>
            <img src="https://cdn.magicpatterns.com/uploads/d9zPQuNrTr8BSQu1zYBo2M/heylloyd-image-1769816278400.png" alt="Venezuela: La verdad que el mundo no quiso ver - Libro" className="relative w-full max-w-[280px] sm:max-w-sm lg:max-w-md rounded-lg shadow-2xl shadow-black border border-zinc-800" data-id="element-58" />
          </div>
        </motion.div>
      </div>
    </section>;
}